<template>
    <select class="citylist" @change="redirectToCity($event.target.value)">
        <option v-for="city in cities" :value="city.link" v-bind:key=city.id>{{ city.name }}</option>
    </select>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
      name: 'Cities',
      computed: mapGetters({
        cities: 'allCities'
      }),
      methods: {
        redirectToCity: function (link) {
          window.location = link
        }
      },
      created () {
        this.$store.dispatch('getAllCities')
      }
    }
</script>

<style scoped>
  .citylist {
    position: absolute;
    color: #005C9C;
  }
</style>



// WEBPACK FOOTER //
// src/components/cities/Selector.vue